import React from "react";
import "../styles/CourseStudy.css";

interface CourseHeaderProps {
  title: string;
  description?: string;
  totalModules: number;
  completedSections: number;
  totalSections: number;
}

const CourseHeader: React.FC<CourseHeaderProps> = ({
  title,
  description,
  totalModules,
  completedSections,
  totalSections,
}) => {
  const progress =
    totalSections > 0
      ? Math.round((completedSections / totalSections) * 100)
      : 0;

  return (
    <header className="course-header">
      <div className="course-header__overlay">
        <div className="course-header__content">
          <div className="course-header__left">
            <span className="course-badge">Course Study</span>

            <h1 className="course-title">{title}</h1>

            {description && (
              <p className="course-description">{description}</p>
            )}

            <div className="course-meta">
              <div className="meta-card">
                <span className="meta-label">Modules</span>
                <h3>{totalModules}</h3>
              </div>

              <div className="meta-card">
                <span className="meta-label">Progress</span>
                <h3>{progress}%</h3>
              </div>

              <div className="meta-card">
                <span className="meta-label">Completed</span>
                <h3>
                  {completedSections}/{totalSections}
                </h3>
              </div>
            </div>
          </div>

          <div className="course-header__right">
            <div className="progress-ring-card">
              <div className="progress-ring">
                <svg viewBox="0 0 120 120">
                  <circle cx="60" cy="60" r="52" className="progress-ring-bg" />

                  <circle
                    cx="60"
                    cy="60"
                    r="52"
                    className="progress-ring-fill"
                    strokeDasharray={327}
                    strokeDashoffset={327 - (327 * progress) / 100}
                  />
                </svg>

                <div className="progress-text">
                  <span>{progress}%</span>
                  <small>Complete</small>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default CourseHeader;
